import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'ToolbarItem' })({
    container: {
        position: 'relative',
        display: 'flex',
        width: 88,
        boxSizing: 'border-box',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 12,
        borderRadius: 16,
        border: '1px solid #ECECEC',
        transition: 'all 0.2s',
        cursor: 'pointer',
        background: '#FFF',
        color: '#2D2D2D',
        opacity: 0.7,
        '&:hover': {
            opacity: 1,
            background: '#F8F8F8'
        }
    },
    icon: {
        marginTop: 8,
        marginBottom: 12
    },
    title: {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '18px'
    },
    _hidden: {
        visibility: 'hidden'
    }
});
